/* Add to cart */

function csCartAltText(value) {
  return String(value || 'SupplyShop product')
    .split(String.fromCharCode(38)).join('&amp;')
    .split(String.fromCharCode(60)).join('&lt;')
    .split(String.fromCharCode(62)).join('&gt;')
    .split(String.fromCharCode(34)).join('&quot;')
    .split(String.fromCharCode(39)).join('&#39;');
}

(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{return window.console;}catch(err){return window.console={};}})());

var check_countdown = 0;
var qs_quantity = '';

var GLOBAL = {
  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      //searchPlaceholder();
      var $cta = $('.add-to-cart').not('[data-purchase-trigger]');
      if($(window).innerWidth() > 767 ){
        
          $cta.bind( 'click', addToCart );
        
      }
      else { $cta.bind( 'click', directAddToCart ); }
      $('.cart-form .clearAllCart').bind( 'click', clearAllCart );
    }
  },
  templateIndex : { init: function(){ }  },
  templateProduct : { init: function(){ }  },
  templateCart : { init: function(){ }  }
}

var UTIL = {
  fire : function(func,funcname, args){
    var namespace = GLOBAL;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },
  loadEvents : function(){
    var bodyId = document.body.id;
    // hit up common first.
    UTIL.fire('common');
    // do all the classes too.
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);

/* Fly image to Cart */
function flyToCart(imgobj, cart, time){
  
  if(imgobj){
    var imgsrc = imgobj.attr('src');

    imgobj.animate_from_to(cart, {
      pixels_per_second: time, 
      initial_css: {
        'image': imgsrc
      },
      callback: function(){
      }
    });
  }
}

/* Popup notify add-to-cart */
function notifyProduct($info){
    $.jGrowl($info,{
      position:'center',
      life: 500000
    });	
}

function getLiftGateVariantId(){
  var id = 0;
  try {
    id = Number(window.SS_LIFT_GATE_VARIANT_ID || 0);
    if (!id) id = Number(localStorage.getItem('ss_lift_gate_variant_id') || 0);
  } catch (e) {}
  if (!id || isNaN(id)) id = 0;
  return id;
}

function isLiftGateServiceItem(item){
  var id = getLiftGateVariantId();
  if (!id || !item) return false;
  var vid = Number(item.variant_id || item.id || 0);
  return vid === id;
}

function getRenderableItemCount(cart){
  if (!cart || !Array.isArray(cart.items)) return 0;
  var id = getLiftGateVariantId();
  if (!id) return Number(cart.item_count || 0);

  var count = 0;
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    if (isLiftGateServiceItem(item)) continue;
    count += Number(item.quantity || 0);
  }
  return count;
}

function cartCountText(count){
  var n = parseInt(count, 10);
  if (isNaN(n)) n = 0;
  if (n === 1) return "There is 1 item in your cart.";
  return "There are " + n + " items in your cart.";
}

function renderAjaxCartItems(cart) {
  var $wrap = $('.ajax-cart-items');
  if (!$wrap.length) return;

  if (!cart || !cart.items || !cart.items.length) {
    $wrap.html('<div class="ajax-cart-items__empty">Your cart is empty.</div>');
    return;
  }

  var html = '<div class="ajax-cart-items__list">';
  var rendered = 0;
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    var line = i + 1;
    if (isLiftGateServiceItem(item)) continue;
    var img = item.image ? Shopify.resizeImage(item.image, 'compact') : '';
    var title = item.product_title || item.title || '';
    var url = item.url || '#';
    var qty = item.quantity || 0;
    var price = '<span class="money">' + Shopify.formatMoney(item.price, cart_money_format) + '</span>';
    var altTitle = csCartAltText(title || 'SupplyShop product');

    rendered++;
    html += '<div class="ajax-cart-item" data-variant-id="' + item.variant_id + '" data-line="' + line + '">';
    html += '<div class="ajax-cart-item__left">';
    html += img ? ('<a class="ajax-cart-item__img" href="' + url + '"><img src="' + img + '" alt="' + altTitle + '" /></a>') : '';
    html += '<div class="ajax-cart-item__text">';
    html += '<div class="ajax-cart-item__title"><a href="' + url + '">' + title + '</a></div>';
    html += '<div class="ajax-cart-item__meta"><span class="ajax-cart-item__qty">' + qty + ' x</span>' + price + '</div>';
    html += '</div>';
    html += '</div>';
    html += '<button class="ajax-cart-item__remove" type="button" aria-label="Remove" data-line="' + line + '" data-variant-id="' + item.variant_id + '"><span class="cs-icon icon-close"></span></button>';
    html += '</div>';
  }
  html += '</div>';

  if (!rendered) {
    $wrap.html('<div class="ajax-cart-items__empty">Your cart is empty.</div>');
    return;
  }

  $wrap.html(html);
  try { currenciesCallbackSpecial('.ajax-cart-items span.money'); } catch (e) {}
}

function directAddToCart(e){
  if (e) e.preventDefault();
  var form = $(this).closest('form');
  if (form.length) form[0].submit();
}


/* Ajaxy add-to-cart */
function addToCart(e){
  check_countdown = 0;
	if (typeof e !== 'undefined') e.preventDefault()
	if($('.refrigerant-disabled').length) {
		if ($('#epa_number').val().length) {
					$('#ajax-cart-modal').show();
					$('.error-message').removeClass('activated')

					var $this = $(this);
					var form = $this.closest('form');
					$.ajax({
						type: 'POST',
						url: '/cart/add.js',
						data: form.serialize(),
						dataType: 'json',
						error: addToCartFail,
						success: addToCartSuccess,
						cache: false
					});
					// Hide Modal
					$('.modal').modal('hide');

		} else {
			if ($('.error-message').hasClass('activated')) {
                $('.error-message').removeClass('animate-shake');

				setTimeout(function () {
                    $('.error-message').addClass('animate-shake')

                }, 410)
            }
            $('.error-message').addClass('activated')
		}
	} else {
			$('#ajax-cart-modal').show();
			$('.error-message').removeClass('activated')

			var $this = $(this);
			var form = $this.closest('form');
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: form.serialize(),
				dataType: 'json',
				error: addToCartFail,
				success: addToCartSuccess,
				cache: false
			});
			// Hide Modal
			$('.modal').modal('hide');
	}

}

function clearAllCart(){
  if (confirm("Are you sure you want to clear all items in cart?") == true) {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        location.reload(); 
      },
      dataType: 'json'
    });
  } else {
    
  }
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  var $info = 'added to cart';
  var ai_image = '<a href="'+ jqXHR['url'] +'"><img src="'+ Shopify.resizeImage(jqXHR['image'], 'medium') +'" alt="'+ jqXHR['title'] +'"/></a>';
  var ai_name = '<a href="'+ jqXHR['url'] +'">'+ jqXHR['product_title'] + '</a>';
  var ai_price = '<span class="money">'+Shopify.formatMoney(jqXHR['price'], cart_money_format)+'</span>';  
  var ai_variant = ""; if(jqXHR['variant_title'] != null) ai_variant = 'Variant: '+jqXHR['variant_title'];
  var ai_qty = 'Qty: x'+$('.item-quantity'+qs_quantity).val();
  //load data to Ajax Cart Modal
  $(".ajax-cart-note").removeClass("error");
  $(".ajax-cart-note").html($info);
  $('.ajax-cart-image').html(ai_image);
  $('.ajax-cart-product-title').html(ai_name);
  $('.ajax-cart-price').html(ai_price);
  $('.ajax-cart-variant').html(ai_variant); 
  $('.ajax-cart-qty').html(ai_qty);

  // Avoid "0 items" desync by deriving UI from the real cart payload (not DOM reads).
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '.cart-info .cart-content');
    updateCartDesc(cart);
    $('.ajax-cart-number-product').html(cartCountText(getRenderableItemCount(cart)));
    renderAjaxCartItems(cart);
    $('.ajax-cart-loading').hide();
    $('.ajax-cart-box').show().addClass("fadeIn animated");
    countDown(10);
  });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  var $info = '<div class="error">Add to cart failure!<br/>Error: '+ response.description +'</div>';
  $(".ajax-cart-note").addClass("error");
  $(".ajax-cart-note").html($info);
  $('.ajax-cart-image').html("");
  $('.ajax-cart-product-title').html("");
  $('.ajax-cart-price').html("");
  $('.ajax-cart-variant').html(""); 
  $('.ajax-cart-qty').html("");

  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '.cart-info .cart-content');
    updateCartDesc(cart);
    $('.ajax-cart-number-product').html(cartCountText(getRenderableItemCount(cart)));
    renderAjaxCartItems(cart);
    $('.ajax-cart-loading').hide();
    $('.ajax-cart-box').show().addClass("fadeIn animated");
    countDown(10);
  });
}

function searchPlaceholder(){

  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
      })
    });
  }

}

function ajaxCartHide(){
  $("#ajax-cart-modal").addClass("zoomOut animated").fadeOut();
  $("#ajax-cart-modal").removeClass("zoomOut animated");
  check_countdown = 1;
}

$(document).on('click', '.ajax-cart-item__remove', function(e) {
  e.preventDefault();
  var line = $(this).attr('data-line');
  if (!line) return;

  check_countdown = 0;
  $('.ajax-cart-loading').show();
  $('.ajax-cart-box').hide();

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { line: line, quantity: 0 },
    dataType: 'json',
    success: function(cart) {
      Shopify.updateCartInfo(cart, '.cart-info .cart-content');
      updateCartDesc(cart);
      $('.ajax-cart-number-product').html(cartCountText(getRenderableItemCount(cart)));
      renderAjaxCartItems(cart);
      $('.ajax-cart-loading').hide();
      $('.ajax-cart-box').show();
      countDown(10);
    },
    error: function() {
      Shopify.getCart(function(cart) {
        Shopify.updateCartInfo(cart, '.cart-info .cart-content');
        updateCartDesc(cart);
        $('.ajax-cart-number-product').html(cartCountText(getRenderableItemCount(cart)));
        renderAjaxCartItems(cart);
        $('.ajax-cart-loading').hide();
        $('.ajax-cart-box').show();
      });
    }
  });
});

/* Cart Get/Update Data */
Shopify.updateCartInfo = function(cart, cart_summary_id, cart_count_id) {
    if ((typeof cart_summary_id) === 'string') {
      var cart_summary = jQuery(cart_summary_id);
      if (cart_summary.length) {
        // Start from scratch.
        cart_summary.empty();
        // Pull it all out.
        
        jQuery.each(cart, function(key, value) {
          if (key === 'items') {
            
            if (value.length && getRenderableItemCount(cart) > 0) {
              jQuery('.close-dropdown').on('click', function() {
                $(this).parents('.m_cart-group').find('.dropdown-menu').hide();
                $(this).parents('.m_cart-group').find('.dropdownMobile-toggle').removeClass('active-dropdown');
                $('.show-opacity-dropdown').removeClass('active');
              });
              jQuery('<div class="items control-container cart-items-scroll"></div>').appendTo(cart_summary);
              var table = jQuery(cart_summary_id + ' div.items');
              var hasVendorInCart = false
              
                var vendors = 'Turbo Air, Tape, Tecumseh, Re-Verber-Ray, Reverberray';
              
              jQuery.each(value, function(i, item) {
                if (isLiftGateServiceItem(item)) return;

                var cartItemAlt = csCartAltText(item.product_title || item.title || 'SupplyShop product');
                jQuery('<div class="group_cart_item"><div class="cart-left"><a class="cart-image" href="' + item.url + '"><img src="' + Shopify.resizeImage(item.image, 'compact') + '" alt="' + cartItemAlt + '" title=""/></a></div><div class="cart-right"><div class="cart-title"><a href="' + item.url + '">' + item.title + '</a></div><div class="cart-price"><span class="quantity">' + item.quantity + ' x</span><span class="money">' + Shopify.formatMoney(item.price, cart_money_format) + '</span></div></div><a class="cart-close" title="Remove" href="#" onclick="Shopify.removeItem(' + item.variant_id + '); return false;"><span class="cs-icon icon-close"></span></a></div>').appendTo(table);
                
                  if (vendors.indexOf(item.vendor) !== -1) {
                    hasVendorInCart = true;
                  }
                
              });
                       
                jQuery('<div class="subtotal"><span>Subtotal:</span><span class="cart-total-right money">' + Shopify.formatMoney(cart.total_price, cart_money_format) + '</span></div>').appendTo(cart_summary);

                if (hasVendorInCart) {
                  jQuery('<div class="action"><button class="_btn" onclick="window.location=\'/cart\'">View Cart</button><button class="_btn float-right" onclick="showCheckoutMessage(event);">Check Out</button><div class="Checkout-Message"><p>To complete your order please <a href="/pages/contact" title="Contact Us">contact us</a>.</p></div></div>').appendTo(cart_summary);
                } else {
                  jQuery('<div class="action"><button class="_btn" onclick="window.location=\'/cart\'">View Cart</button><button class="_btn float-right" onclick="window.location=\'/checkout\'">Check Out</button></div>').appendTo(cart_summary);
                }

                var ajaxShippingMessage = "";
                var ajaxShippingText = ajaxShippingMessage ? ajaxShippingMessage.replace(/<[^>]*>/g, '').trim() : '';
                if (ajaxShippingText.length) {
                  jQuery('<div class="free-ship">' + ajaxShippingMessage + '</div>').appendTo(cart_summary);
                }
            
              currenciesCallbackSpecial('.cart-price span.money, .subtotal span.money, .price_text span.money');
              currenciesCallbackSpecial('.ajax-cart-price span.money');
            
            }
            else {
              jQuery('<div class="empty text-center"><em>Your shopping cart is empty. <a href="/collections/all" class="_btn">Continue Shopping</a></em></div>').appendTo(cart_summary);
            }
          }
        });
      }
    }
    // Update cart count.
    if ((typeof cart_count_id) === 'string') {
      var renderableCount = getRenderableItemCount(cart);
      if (renderableCount == 0) { 
        jQuery('#' + cart_count_id).html('your cart is empty');
       
      }
      else if (renderableCount == 1) {
        jQuery('#' + cart_count_id).html('1 item in your cart');
      }
        else {
          jQuery('#' + cart_count_id).html(renderableCount + ' item(s) in the cart');
        }
    }
    wishlist_init();                                       
    wishlist_add();
    /* Update cart info */
    updateCartDesc(cart);
  };

  function showCheckoutMessage(e) {
    e.preventDefault();

    $('.Checkout-Message').fadeIn();
  }
  
  function updateCartDesc(data){
    var $cartLinkText = $('.num-items-in-cart .number');
    //var $cartPrice = '<span class="total"> - '+ Shopify.formatMoney(data.total_price, cart_money_format) +'</span>';
    var renderableCount = getRenderableItemCount(data);
    switch(renderableCount){
      case 0:
        $cartLinkText.html('0');
        break;
      case 1:
        $cartLinkText.html('1');                
        break;
      default:
        $cartLinkText.html(renderableCount);
        break;
    }
    $('.ajax-cart-subtotal').html("<span class='money'>"+Shopify.formatMoney(data.total_price, cart_money_format)+"</span>");
    currenciesCallbackSpecial('.ajax-cart-subtotal span.money');
    $('.price_text').html("<span class='money'>"+Shopify.formatMoney(data.total_price, cart_money_format)+"</span>");
    currenciesCallbackSpecial('.price_text span.money');
  }
  
  Shopify.onCartUpdate = function(cart) {
    Shopify.updateCartInfo(cart, '.cart-info .cart-content', 'shopping-cart');
  };
     
            
  $(window).load(function() {
    // Let's get the cart and show what's in it in the cart box.	
    Shopify.getCart(function(cart) {      
      Shopify.updateCartInfo(cart, '.cart-info .cart-content');		
    });
  });
    
  function countDown(count) {
    if (count > 0) {
       if(count > 1) $(".countDiv").html("This popup will auto close after <span>"+count+"</span> seconds"); else $(".countDiv").html("This popup will auto close after <span>"+count+"</span> second");
      if(check_countdown == 1){
        setTimeout (function() { countDown(0); }, 0);
      }
      else{
        setTimeout (function() { countDown(count-1); }, 1000);
      }
    }
    else
       ajaxCartHide();
  }
